import { Control, Controller, UseFormResetField } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// local imports
import { IHealthLocationList } from 'types/HealthType'
import { IFilteredMeetingRoomList, IMeetingRoomSearch } from 'types/MeetingRoomType'
import {
  DropdownWrapper,
  StyledCustomDropdown,
} from 'components/home/on-campus-services/coiffeur/coiffeur-search-modal/styled'

interface IMeetingFormProps {
  control: Control<IMeetingRoomSearch>
  resetField: UseFormResetField<IMeetingRoomSearch>
  locationList: IHealthLocationList[] | undefined
  roomList: IFilteredMeetingRoomList[] | []
}

function valueTemplate(options: IFilteredMeetingRoomList, props: any) {
  return <div className="selectedVal">{options?.name || props?.placeholder}</div>
}

export default function MeetingRoomSearchForm({ control, resetField, roomList, locationList }: IMeetingFormProps) {
  const { t } = useTranslation()

  return (
    <div className="d-flex flex-column gap-2">
      {/* Location */}
      <Controller
        name="locationId"
        control={control}
        render={({ field }) => (
          <DropdownWrapper>
            <label className="autocomplete-title">{t('most-used-words.location')}</label>
            <i className="autocomplete-icon p-input-icon-left pi pi-map-marker"></i>
            <StyledCustomDropdown
              id="meetingLocation"
              emptyMessage={t('most-used-words.option-not-found')}
              emptyFilterMessage={t('most-used-words.option-not-found')}
              name="locationId"
              placeholder={t('input-texts.choose-location')}
              optionLabel="name"
              optionValue="id"
              valueTemplate={(opt, props) => valueTemplate(opt, props)}
              options={locationList}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.value)
                resetField('meetingRoom')
              }}
            />
          </DropdownWrapper>
        )}
      />

      {/* Meeting Room */}
      <Controller
        name="meetingRoom"
        control={control}
        render={({ field }) => (
          <DropdownWrapper>
            <label className="autocomplete-title">{t('input-texts.meeting-room')}</label>
            {/* <img
              className="autocomplete-icon p-input-icon-left"
              src={""}
              alt="logo"
              width={18}
              height={18}
            /> */}
            <StyledCustomDropdown
              id="meetingRoomDropdown"
              emptyMessage={t('most-used-words.option-not-found')}
              emptyFilterMessage={t('most-used-words.option-not-found')}
              name="meetingRoom"
              placeholder={t('input-texts.choose-meeting-room')}
              optionLabel="name"
              options={roomList}
              value={field.value}
              valueTemplate={(opt, props) => valueTemplate(opt, props)}
              onChange={(e) => {
                field.onChange(e.value)
              }}
            />
          </DropdownWrapper>
        )}
      />
    </div>
  )
}
